/**
 * 政策信息模块配置文件
 * 支持多语言切换
 */
import { deepCloneConfig } from '@/utils/deepCloneConfig'
import { applyPortalZhToRu } from '@/utils/applyPortalZhToRu'
import { L, resolveLocaleImages } from '@/utils/localeAsset'

// 中文配置
const zhCN = {
  // 网站信息
  siteInfo: {
    title: '杨凌农业科技成果转化综合信息服务平台',
    logo: L('shouye/web-logo.png'),
    loginText: '登录',
    registerText: '注册'
  },
  
  // 政策信息页面
  policyInfo: {
    // 页面标题
    title1: '政策',
    title2: '信息',
    subtitle: '科技兴农，信息惠农',
    searchPlaceholder: '请输入关键词',
    searchButton: '搜索',
    
    breadcrumb: {
      home: '首页',
      current: '政策信息'
    },
    
    assets: {
      bannerBg: L('kejirencai/head-bg@2x.png')
    },
    
    filters: {
      typeLabel: '政策类型：',
      deptLabel: '发布部门：',
      timeLabel: '发布时间：',
      datePlaceholder: '选择日期'
    },
    
    // 政策类型列表
    policyTypes: [
      '全部', '项目申报', '政策补助', '荣誉资质', '产业扶持', '人才驱动', 
      '贷款保险', '知识产权', '综合规划', '科技合作', '其他'
    ],
    
    // 发布部门列表
    departments: [
      '全部', '科技', '工信', '财政', '税务', '发改', '商务', 
      '人社', '农业', '文广新', '档案', '知识产权', '其他'
    ],
    
    // 发布时间列表
    timeRanges: [
      '全部', '3个月内', '半年内', '今年', '选择时间'
    ],
    
    // 政策卡片
    policyCard: {
      publishDate: '发布时间：',
      department: '发布部门：'
    },
    
    // 分页
    pagination: {
      pageInfo: '共{total}条，每页显示{pageSize}条',
      firstPage: '首页',
      prevPage: '上一页',
      nextPage: '下一页',
      lastPage: '末页'
    },
    
    // 默认值
    defaults: {
      source: '政策信息',
      department: '未设置',
      policyType: {
        tech: '科技政策',
        interpret: '政策解读'
      }
    }
  },
  
  // 功能模块
  modules: [
    {
      id: 'home',
      name: '首页',
      icon: '',
      link: '/index'
    },
    {
      id: 'innovation',
      name: '走进杨凌',
      icon: '',
      link: '/innovation'
    },
    {
      id: 'supply',
      name: '供需中心',
      icon: '',
      link: '/supply-demand'
    },
    {
      id: 'evaluation',
      name: '价值评估',
      icon: '',
      link: '/value-assessment'
    },
    {
      id: 'manager',
      name: '技术经理人',
      icon: '',
      link: '/manager'
    },
    {
      id: 'transaction',
      name: '交易中心',
      icon: '',
      link: '/transaction'
    },
    {
      id: 'service',
      name: '科创服务',
      icon: '',
      link: '/innovation-service'
    },
    {
      id: 'talent',
      name: '科技人才',
      icon: '',
      link: '/talent'
    },
    {
      id: 'enterprise',
      name: '农业企业',
      icon: '',
      link: '/agriculture-enterprise'
    },
    {
      id: 'policy',
      name: '政策信息',
      icon: '',
      link: '/policy'
    }
  ],
  
  // 页脚信息
  footer: {
    copyright: '',
    support: '技术支持：浪潮软件科技有限公司'
  }
}

// 英文配置（预留）
const enUS = {
  siteInfo: {
    title: 'Yangling Agriculture Technology Achievements Transformation Comprehensive Information Platform',
    logo: L('shouye/web-logo.png'),
    loginText: 'Login',
    registerText: 'Register'
  },
  modules: [
    { id: 'home', name: 'Home', icon: '', link: '/index' },
    { id: 'innovation', name: 'Innovation Yangling', icon: '', link: '/innovation' },
    { id: 'supply', name: 'Supply & Demand', icon: '', link: '/supply-demand' },
    { id: 'evaluation', name: 'Value Assessment', icon: '', link: '/value-assessment' },
    { id: 'manager', name: 'Tech Managers', icon: '', link: '/manager' },
    { id: 'transaction', name: 'Transaction Center', icon: '', link: '/transaction' },
    { id: 'service', name: 'Innovation Services', icon: '', link: '/innovation-service' },
    { id: 'talent', name: 'Tech Talent', icon: '', link: '/talent' },
    { id: 'enterprise', name: 'Agricultural Enterprises', icon: '', link: '/agriculture-enterprise' },
    { id: 'policy', name: 'Policy', icon: '', link: '/policy' }
  ],
  footer: {
    copyright: '',
    support: 'Technical Support: Inspur Software Technology Co., Ltd.'
  },
  policyInfo: {
    title1: 'Policy',
    title2: 'Information',
    subtitle: 'Technology Agriculture, Information Benefits Agriculture',
    searchPlaceholder: 'Please enter keywords',
    searchButton: 'Search',
    
    breadcrumb: {
      home: 'Home',
      current: 'Policy Information'
    },
    
    assets: {
      bannerBg: L('kejirencai/head-bg@2x.png')
    },
    
    filters: {
      typeLabel: 'Policy Type:',
      deptLabel: 'Department:',
      timeLabel: 'Publish Time:',
      datePlaceholder: 'Select Date'
    },
    
    policyTypes: [
      '全部', 'Project Declaration', 'Policy Subsidy', 'Honor Qualification', 'Industry Support', 'Talent Drive',
      'Loan Insurance', 'Intellectual Property', 'Comprehensive Planning', 'Technology Cooperation', 'Other'
    ],
    
    departments: [
      '全部', 'Science', 'Industry', 'Finance', 'Tax', 'Development', 'Commerce',
      'HR', 'Agriculture', 'Culture', 'Archive', 'IP', 'Other'
    ],
    
    timeRanges: [
      '全部', 'Within 3 months', 'Within half a year', 'This year', 'Select time'
    ],
    
    policyCard: {
      publishDate: 'Publish Date:',
      department: 'Department:'
    },
    
    pagination: {
      pageInfo: 'Total {total} items, {pageSize} per page',
      firstPage: 'First',
      prevPage: 'Previous',
      nextPage: 'Next',
      lastPage: 'Last'
    },

    defaults: {
      source: 'Policy Information',
      department: 'N/A',
      policyType: {
        tech: 'S&T Policy',
        interpret: 'Interpretation'
      }
    }
  }
}

const ruRU = applyPortalZhToRu(deepCloneConfig(zhCN))

// 当前语言配置
let currentLang = 'zh-CN'

// 语言配置映射
const langMap = {
  'zh-CN': zhCN,
  'en-US': enUS,
  'ru-RU': ruRU
}

// 获取配置
export function getPolicyConfig(lang) {
  const locale = lang || currentLang
  const config = langMap[locale] || zhCN
  return resolveLocaleImages(config, locale)
}

// 设置语言
export function setLanguage(lang) {
  if (langMap[lang]) {
    currentLang = lang
  }
}

// 获取当前语言
export function getCurrentLanguage() {
  return currentLang
}

export default {
  getPolicyConfig,
  setLanguage,
  getCurrentLanguage
}
